<footer class="digital-footer row pb-3">
  <div class="col-2 col-md-1 col-img">
    <a
      *ngFor="let logoLink of footerLinks?.secondaryLinks"
      attr.aria-label="{{ globalContent?.globalMessages?.goHome }}"
      role="tab"
      tmoAnchorDetect
      [link]="logoLink?.href"
      [isNewTab]="logoLink?.newTab"
      [seoHref]="true"
      accesskey="1"
    >
      <img
        id="tmobile-image"
        class="pt-4 ps-lg-3"
        src="{{ logoLink?.labelImage }}"
        alt="T-Mobile Logo"
      />
    </a>
  </div>
  <div
    class="col-10 col-md-3 col-social-media order-md-2 d-md-flex justify-content-md-end pt-4"
    role="menu"
  >
    <div>
      <a
        class="me-4"
        *ngFor="let socialMediaLink of footerLinks?.socialMediaLinks; let ind = index"
        tmoAnchorDetect
        [link]="socialMediaLink?.href"
        [isNewTab]="socialMediaLink?.newTab"
        [seoHref]="true"
        (click)="onMenuClick(socialMediaLink?.href, socialMediaLink?.newTab, socialMediaLink?.name)"
        title="{{ socialMediaLink?.name }}"
        role="menuitem"
        id="cta-default-731_{{ ind }}"
      >
        <i [ngClass]="socialMediaLink.cssClass"></i>
      </a>
      <p class="copyright fs-12 font-weight-light pt-2">{{ footerData?.copyRightLink }}</p>
    </div>
  </div>
  <div class="col-12 col-md-8 order-md-1" role="navigation">
    <p class="lead fs-12 links pt-4 font-weight-bold d-flex flex-wrap" role="menu">
      <a
        *ngFor="let leftLink of footerLinks?.leftLinks; let ind = index"
        class="main me-3"
        tmoAnchorDetect
        [link]="leftLink?.href"
        [isNewTab]="leftLink?.newTab"
        [seoHref]="true"
        (click)="onMenuClick(leftLink?.href, leftLink?.newTab, leftLink?.name)"
        id="cta-default-189_{{ ind }}"
        >{{ leftLink?.name }}</a
      >
    </p>
    <p class="lead fs-12 links font-weight-light d-flex flex-wrap" role="menu">
      <a
        class="me-3"
        *ngFor="let smallLink of footerLinks?.smallLinks; let ind = index"
        tmoAnchorDetect
        [link]="smallLink?.href"
        [isNewTab]="smallLink?.newTab"
        [seoHref]="true"
        (click)="onMenuClick(smallLink?.href, smallLink?.newTab, smallLink?.name)"
        role="menuitem"
        [innerHtml]="smallLink?.name"
        id="cta-default-191_{{ ind }}"
      ></a>
    </p>
  </div>
</footer>
